// Typelizer digest cae15f6540fa78414a601ac74a52867c
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from './runtime'
import { buildUrl } from './runtime'

export default {
  /** GET /users/:id/profile */
  profile: (
    params: { id: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'get'> => ({
    url: buildUrl('/users/:id/profile', params, options),
    method: 'get',
  }),

  /** GET /users/:id/edit_profile */
  editProfile: (
    params: { id: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'get'> => ({
    url: buildUrl('/users/:id/edit_profile', params, options),
    method: 'get',
  }),

  /** POST /users/:id/invite */
  invite: (
    params: { id: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'post'> => ({
    url: buildUrl('/users/:id/invite', params, options),
    method: 'post',
  }),

  /** POST /users/:id/divest */
  divest: (
    params: { id: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'post'> => ({
    url: buildUrl('/users/:id/divest', params, options),
    method: 'post',
  }),

  /** POST /users/:id/unlock */
  unlock: (
    params: { id: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'post'> => ({
    url: buildUrl('/users/:id/unlock', params, options),
    method: 'post',
  }),

  /** GET /users/export_excel */
  exportExcel: (options?: RouteOptions): RouteDefinition<'get'> => ({
    url: buildUrl('/users/export_excel', {}, options),
    method: 'get',
  }),

  /** GET /users */
  index: (options?: RouteOptions): RouteDefinition<'get'> => ({
    url: buildUrl('/users', {}, options),
    method: 'get',
  }),

  /** POST /users */
  create: (options?: RouteOptions): RouteDefinition<'post'> => ({
    url: buildUrl('/users', {}, options),
    method: 'post',
  }),

  /** GET /users/new */
  new: (options?: RouteOptions): RouteDefinition<'get'> => ({
    url: buildUrl('/users/new', {}, options),
    method: 'get',
  }),

  /** GET /users/:id/edit */
  edit: (
    params: { id: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'get'> => ({
    url: buildUrl('/users/:id/edit', params, options),
    method: 'get',
  }),

  /** GET /users/:id */
  show: (
    params: { id: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'get'> => ({
    url: buildUrl('/users/:id', params, options),
    method: 'get',
  }),

  /** PATCH /users/:id */
  update: (
    params: { id: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'patch'> => ({
    url: buildUrl('/users/:id', params, options),
    method: 'patch',
  }),

  /** DELETE /users/:id */
  destroy: (
    params: { id: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'delete'> => ({
    url: buildUrl('/users/:id', params, options),
    method: 'delete',
  }),

  /** GET /students */
  students: (options?: RouteOptions): RouteDefinition<'get'> => ({
    url: buildUrl('/students', {}, options),
    method: 'get',
  }),
}
